<template>
  <s-loading-button
    class="excel-export-button text-uppercase"
    variant="outline-green"
    :size="size"
    @click="proxyClick"
  >
    <span
      v-if="!loading"
      class="fas fa-file-excel excel-export-button__icon"
    />
    <span>
      {{ $t('buttons.excel-export') }}
    </span>
  </s-loading-button>
</template>

<script>
import ExportButtonMixin from '../mixins/exportButtonMixin';

export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  mixins: [
    ExportButtonMixin,
  ],
};
</script>

<style lang="sass" scoped>
@import "export-button-mixin"

.excel-export-button
  @include export-button()
</style>
